/*
  American truck pages: sticky contact bar, jump nav highlighting,
  enquiry intents (pre-filling the form from the button pressed) and click tracking.
*/
(function () {
  if (window.truckActionsLoaded) return;
  window.truckActionsLoaded = true;

  var root = document.querySelector('.tp');
  if (!root) return;

  /* ---------- Tracking ---------- */
  // Sent to Shopify customer events (custom pixels), plus gtag or the GTM dataLayer when present.
  function track(name, params) {
    params = params || {};
    params.page_path = window.location.pathname;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) {}
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    } else if (Array.isArray(window.dataLayer)) {
      var payload = { event: name };
      for (var key in params) payload[key] = params[key];
      window.dataLayer.push(payload);
    }
  }

  /* ---------- Enquiry intents ---------- */
  function findForm(targetId) {
    var target = targetId && document.getElementById(targetId);
    return target ? target.querySelector('form') : null;
  }

  function applyIntent(link) {
    var form = findForm((link.getAttribute('href') || '').replace('#', ''));
    if (!form) return;

    var type = form.querySelector('input[name="contact[Enquiry type]"]');
    if (type) {
      if (!type.dataset.base) type.dataset.base = type.value;
      type.value = type.dataset.base + ' – ' + link.dataset.tpIntent;
    }

    var message = link.dataset.tpMessage;
    var field = form.querySelector('textarea[required]');
    if (message && field && (field.value.trim() === '' || field.value === field.dataset.tpPrefill)) {
      field.value = message;
      field.dataset.tpPrefill = message;
    }

    var gvm = link.dataset.tpGvm;
    var gvmSelect = form.querySelector('select[name="contact[GVM upgrade interest]"]');
    if (gvm && gvmSelect && gvmSelect.value === '') gvmSelect.value = gvm;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-tp-track], [data-tp-intent]');
    if (!link || !root.contains(link)) return;
    if (link.dataset.tpIntent) applyIntent(link);
    if (link.dataset.tpTrack) {
      track('truck_cta_click', { cta: link.dataset.tpTrack, intent: link.dataset.tpIntent || '' });
    }
  });

  /* ---------- In-page anchors ---------- */
  // The theme's smooth scroll only offsets the header, so these links opt out of it (.no-scroll)
  // and also clear the sticky jump nav. Without JS, the scroll-margin-top in truck-pages.css applies.
  var jump = root.querySelector('.tp-jump');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollOffset() {
    var styles = getComputedStyle(document.documentElement);
    var offset = parseFloat(styles.getPropertyValue('--header-height-live')) || parseFloat(styles.getPropertyValue('--header-height')) || 0;
    if (jump && getComputedStyle(jump).position === 'sticky') offset += jump.offsetHeight;
    return offset + 16;
  }

  Array.prototype.forEach.call(root.querySelectorAll('a[href^="#"]'), function (link) {
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    link.classList.add('no-scroll');
    link.addEventListener('click', function (event) {
      event.preventDefault();
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - scrollOffset(),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      if (!target.matches('a, button, input, select, textarea, [tabindex]')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  });

  Array.prototype.forEach.call(root.querySelectorAll('form'), function (form) {
    form.addEventListener('submit', function () {
      var type = form.querySelector('input[name="contact[Enquiry type]"]');
      track('truck_enquiry_submit', { enquiry_type: type ? type.value : '' });
    });
  });

  /* ---------- Swipeable card rows (mobile) ---------- */
  // Rows without links of their own need to be focusable so keyboard users can scroll them.
  var swipeRows = Array.prototype.slice.call(root.querySelectorAll('.tp-grid, .tp-details, .tp-steps'));
  function markSwipeRows() {
    swipeRows.forEach(function (row) {
      var scrolls = row.scrollWidth > row.clientWidth + 1;
      if (scrolls && !row.querySelector('a, button')) {
        row.setAttribute('tabindex', '0');
        row.setAttribute('role', 'group');
        if (!row.hasAttribute('aria-label')) row.setAttribute('aria-label', 'Swipe for more');
      } else if (!scrolls && row.getAttribute('aria-label') === 'Swipe for more') {
        row.removeAttribute('tabindex');
        row.removeAttribute('role');
        row.removeAttribute('aria-label');
      }
    });
  }
  markSwipeRows();
  window.addEventListener('resize', markSwipeRows, { passive: true });

  /* ---------- Sticky contact bar + jump nav highlighting ---------- */
  var bar = root.querySelector('[data-tp-bar]');
  var hero = root.querySelector('.tp-hero');
  var enquiry = bar && document.getElementById(bar.dataset.enquiry);
  var jumpList = jump && jump.querySelector('ul');
  var jumpLinks = jump ? Array.prototype.slice.call(jump.querySelectorAll('li a[href^="#"]')) : [];
  var jumpTargets = jumpLinks.map(function (link) {
    return document.getElementById(link.getAttribute('href').slice(1));
  });
  var formFocused = false;
  var barVisible = false;
  var ticking = false;

  root.addEventListener('focusin', function (event) {
    if (event.target.matches('input, select, textarea')) { formFocused = true; update(); }
  });
  root.addEventListener('focusout', function (event) {
    if (event.target.matches('input, select, textarea')) { formFocused = false; update(); }
  });

  function setBar(visible) {
    if (!bar || visible === barVisible) return;
    barVisible = visible;
    bar.classList.toggle('is-visible', visible);
    if (visible) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    // Lets fixed widgets (scroll-to-top, Podium chat) move up out of the bar's way.
    if (visible) document.documentElement.style.setProperty('--tp-bar-height', bar.offsetHeight + 'px');
    document.documentElement.classList.toggle('tp-bar-on', visible);
  }

  function highlight() {
    if (!jumpLinks.length) return;
    var offset = jump.getBoundingClientRect().bottom + 24;
    var active = -1;
    jumpTargets.forEach(function (target, i) {
      if (target && target.getBoundingClientRect().top <= offset) active = i;
    });
    jumpLinks.forEach(function (link, i) {
      var on = i === active;
      link.classList.toggle('is-active', on);
      if (on) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
    });
    var current = jumpLinks[active];
    if (current && jumpList && jumpList.scrollWidth > jumpList.clientWidth) {
      var left = current.parentElement.offsetLeft;
      if (left < jumpList.scrollLeft || left + current.offsetWidth > jumpList.scrollLeft + jumpList.clientWidth) {
        jumpList.scrollLeft = left - 16;
      }
    }
  }

  function update() {
    ticking = false;
    if (bar && hero && enquiry) {
      var pastHero = hero.getBoundingClientRect().bottom < 0;
      var beforeForm = enquiry.getBoundingClientRect().top > window.innerHeight * 0.85;
      var barShown = getComputedStyle(bar).display !== 'none'; // the bar is mobile and tablet only
      setBar(barShown && pastHero && beforeForm && !formFocused);
    }
    highlight();
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
